module.exports = __webpack_public_path__ + "img/appqrcode.754e332e.png";